import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReviewIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 110,
	height: 110,
	viewBox: "0 0 110 110",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 55,
			cy: 55,
			r: 54,
			stroke: "#E5E7EB",
			strokeWidth: 1.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 30,
			y1: 36,
			x2: 70,
			y2: 36,
			stroke: "#2047F4",
			strokeWidth: 4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 30,
			y1: 50,
			x2: 70,
			y2: 50,
			stroke: "#2047F4",
			strokeWidth: 4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 30,
			y1: 64,
			x2: 56,
			y2: 64,
			stroke: "#D4DBEC",
			strokeWidth: 4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 62,
			cy: 58,
			r: 14,
			fill: "white",
			stroke: "#2047F4",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 72,
			y1: 68,
			x2: 82,
			y2: 78,
			stroke: "#2047F4",
			strokeWidth: 5,
			strokeLinecap: "round"
		})
	]
});
export default SvgReviewIcon;
